export enum AccordionPanelStates {
  ACTIVE_CONVERSATIONS,
  SEARCH_CONVERSATIONS
}
